//@ts-ignore
import * as initials from "initials";
import { IFormsState } from "../../store/forms/types";
import { IFieldBoomformInitials } from "../../store/fields/initails";
import { IFormSettings } from "../../store/settings/types";

export const fieldsInitials: IFieldBoomformInitials = initials["default"]["fieldsInitials"];
export const formInitials: IFormsState = initials["default"]["formInitials"];
export const settingsInitials: IFormSettings = initials["default"]["settingsInitials"];
